// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════
   QUITTANCE INDEMNITÉ - CSS propre, sans conflits
   NB : duplication maintenue dans \`quittanceIndemniteRaw.js\`
        (utilisé par l'iframe d'impression - CRA ne supporte pas \`?raw\`).
        Synchroniser les deux fichiers à chaque modification.
   ══════════════════════════════════════════════ */

.quittance-container {
    width: 210mm;
    min-height: 297mm;
    background: white;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 13px;
    color: #000;
    box-sizing: border-box;
    padding: 12mm 15mm;
    line-height: 1.5;
}

/* ── En-tête ──
   Trois zones : bureau à gauche, emblème au centre, date de règlement à droite.
   Les deux zones latérales partagent la même base de largeur (\`flex: 1 1 0\`) pour
   que l'emblème tombe au centre optique de la feuille, et non au milieu de ce qui
   reste une fois le texte posé. */
.quittance-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 10px;
}

.quittance-header-bureau {
    flex: 1 1;
    min-width: 0;
}

.quittance-header-reglement {
    flex: 1 1;
    min-width: 0;
    text-align: right;
    font-size: 11px;
    color: #333;
}

.quittance-header-text-main {
    font-weight: 700;
    font-size: 15px;
    color: #1a6b3c;
    letter-spacing: 0.5px;
}

.quittance-header-text-sub {
    font-size: 12px;
    color: #555;
    margin-top: 2px;
}

.quittance-separator {
    border: none;
    border-bottom: 3px solid #1a6b3c;
    margin: 0 0 14px 0;
}

/* ── Titre ── */
.quittance-title-wrapper {
    text-align: center;
    margin-bottom: 16px;
}

.quittance-title {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 2px;
    margin: 0;
    text-transform: uppercase;
}

/* ── Blocs sections ── */
.quittance-block {
    margin-bottom: 12px;
}

.quittance-block-title {
    margin: 0;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #fff;
    background: #1a6b3c;
    text-transform: uppercase;
}

/* ── Tableaux - règle unique, pas de surcharge ── */
.quittance-ref-table,
.quittance-payment-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    table-layout: auto;
}

.quittance-ref-table td {
    padding: 6px 10px;
    border: 0.5px solid #a7f3d0;
    vertical-align: middle;
    font-size: 13px;
}

.quittance-ref-label {
    width: 42%;
    font-weight: 600;
    background: #f0fdf4;
}

.quittance-ref-value {
    font-weight: 400;
}

.quittance-payment-table th,
.quittance-payment-table td {
    padding: 6px 8px;
    border: 0.5px solid #a7f3d0;
    vertical-align: middle;
    font-size: 12px;
    text-align: left;
}

.quittance-payment-table thead tr {
    background: #f0fdf4;
}

.quittance-payment-table th {
    font-weight: 700;
    font-size: 11px;
    text-transform: uppercase;
}

/* ── Préjudices réglés et total, en deux encadrés ──
   \`align-items: start\` : les deux encadrés gardent leur hauteur propre. Étirés à
   la même hauteur, un libellé de préjudice sur deux lignes laissait sous le
   montant un vide qui se lisait comme une case à remplir. */
.quittance-totaux {
    display: flex;
    gap: 16px;
    align-items: start;
}

.quittance-encadre {
    flex: 1 1;
    min-width: 0;
    border: 0.5px solid #a7f3d0;
}

/* Le total est la valeur qu'on vient vérifier : il ne suit pas la largeur du
   libellé, il occupe une colonne fixe et lisible. */
.quittance-encadre--total {
    flex: 0 0 210px;
}

.quittance-encadre-titre {
    background: #1a6b3c;
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
    padding: 7px 10px;
}

.quittance-encadre-valeur {
    padding: 7px 10px;
    font-size: 13px;
}

.quittance-encadre-montant {
    text-align: right;
    font-weight: 700;
}

/* ── Texte engagement ── */
.quittance-engagement {
    margin-top: 16px;
    font-size: 13px;
    line-height: 1.9;
}

.quittance-engagement p {
    margin: 4px 0;
    text-align: justify;
}

/* ── Signatures ── */
.quittance-signatures {
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    gap: 24px;
}

.quittance-signature-col {
    flex: 1 1;
    text-align: center;
}

.quittance-signature-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #1a6b3c;
    border-bottom: 1px solid #1a6b3c;
    padding-bottom: 4px;
    display: block;
}

.quittance-signature-space {
    height: 45px;
}

/* ── Pied de page ── */
.quittance-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    font-size: 12px;
    border-top: 0.5px solid #a7f3d0;
    padding-top: 8px;
    color: #555;
}

.quittance-footer-dots {
    color: #1a6b3c;
    font-family: monospace;
}

/* ══ IMPRESSION ══ */
@media print {
    @page {
        size: A4 portrait;
        margin: 0;
    }

    .quittance-container {
        width: 210mm;
        min-height: 297mm;
        padding: 12mm 15mm;
        margin: 0;
        box-shadow: none;
        font-size: 13px;
        print-color-adjust: exact !important;
    }
}

/* ── En-tete commun aux documents du Bureau ─────────────────────────────────
   Reproduit l'en-tete de l'offre CIMA (jsPDF) : trois colonnes, embleme au
   centre, filet vert. Voir EnteteDocumentBncb.js - les deux implementations
   sont a tenir en accord, elles ne partagent aucun code. */
.bncb-entete {
    margin-bottom: 14px;
}

.bncb-entete-accent {
    height: 3px;
    background: #1a6b3c;
    margin-bottom: 8px;
}

/* Les colonnes laterales partagent la meme base de largeur : l'embleme tombe
   ainsi au centre optique de la feuille, et non au milieu de ce qui reste une
   fois les titres poses. */
.bncb-entete-grille {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding-bottom: 8px;
    border-bottom: 1.2px solid #1a6b3c;
}

.bncb-entete-col {
    flex: 1 1;
    min-width: 0;
    text-align: center;
}

.bncb-entete-col--centre {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.bncb-entete-titre {
    font-size: 10.5px;
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: .2px;
    color: #000;
    text-transform: uppercase;
}

.bncb-entete-logo {
    width: 62px;
    height: 62px;
    object-fit: contain;
}

.bncb-entete-legende {
    font-size: 7.5px;
    color: #8c8c8c;
    margin-top: 2px;
}

.bncb-entete-mention {
    text-align: right;
    font-size: 11px;
    color: #333;
    margin-top: 6px;
}

/* Les en-tetes de colonnes sont centres : une etiquette courte calee a gauche
   au-dessus d'une valeur large se lit comme si elle appartenait a la colonne
   precedente. */
.quittance-payment-table th {
    text-align: center;
}

/* Les prix sont soulignes : sur une decharge, ce sont les valeurs qu'on vient
   verifier, et le soulignement les designe sans les alourdir. */
.quittance-montant {
    text-decoration: underline;
    text-underline-offset: 2px;
}

/* De l'air avant les signatures : collees au dernier paragraphe, elles se
   lisaient comme la suite du texte plutot que comme un bloc a remplir. */
.quittance-signatures {
    margin-top: 54px;
}

/* ── Pied de page commun aux documents du Bureau ────────────────────────────
   Repris de l'offre CIMA : un filet gris, puis les coordonnees en petit.
   Voir PiedDocumentBncb.js. */
.bncb-pied {
    margin-top: 18px;
    padding-top: 6px;
    border-top: 0.6px solid #c8c8c8;
    text-align: center;
    font-size: 8px;
    line-height: 1.5;
    color: #969696;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/quittanceIndemnite.css"],"names":[],"mappings":"AAAA;;;;;mDAKmD;;AAEnD;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,yCAAyC;IACzC,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;;kCAIkC;AAClC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,oDAAoD;AACpD;;IAEI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;;4DAG4D;AAC5D;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,SAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;oDACoD;AACpD;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA,qBAAqB;AACrB;IACI;QACI,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,SAAS;QACT,gBAAgB;QAChB,eAAe;QAEf,oCAAoC;IACxC;AACJ;;AAEA;;;2DAG2D;AAC3D;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;2BAE2B;AAC3B;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,SAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;;gBAEgB;AAChB;IACI,kBAAkB;AACtB;;AAEA;gEACgE;AAChE;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;yEACyE;AACzE;IACI,gBAAgB;AACpB;;AAEA;;8BAE8B;AAC9B;IACI,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":["/* ══════════════════════════════════════════════\n   QUITTANCE INDEMNITÉ - CSS propre, sans conflits\n   NB : duplication maintenue dans `quittanceIndemniteRaw.js`\n        (utilisé par l'iframe d'impression - CRA ne supporte pas `?raw`).\n        Synchroniser les deux fichiers à chaque modification.\n   ══════════════════════════════════════════════ */\n\n.quittance-container {\n    width: 210mm;\n    min-height: 297mm;\n    background: white;\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 13px;\n    color: #000;\n    box-sizing: border-box;\n    padding: 12mm 15mm;\n    line-height: 1.5;\n}\n\n/* ── En-tête ──\n   Trois zones : bureau à gauche, emblème au centre, date de règlement à droite.\n   Les deux zones latérales partagent la même base de largeur (`flex: 1 1 0`) pour\n   que l'emblème tombe au centre optique de la feuille, et non au milieu de ce qui\n   reste une fois le texte posé. */\n.quittance-header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 10px;\n}\n\n.quittance-header-bureau {\n    flex: 1 1 0;\n    min-width: 0;\n}\n\n.quittance-header-reglement {\n    flex: 1 1 0;\n    min-width: 0;\n    text-align: right;\n    font-size: 11px;\n    color: #333;\n}\n\n.quittance-header-text-main {\n    font-weight: 700;\n    font-size: 15px;\n    color: #1a6b3c;\n    letter-spacing: 0.5px;\n}\n\n.quittance-header-text-sub {\n    font-size: 12px;\n    color: #555;\n    margin-top: 2px;\n}\n\n.quittance-separator {\n    border: none;\n    border-bottom: 3px solid #1a6b3c;\n    margin: 0 0 14px 0;\n}\n\n/* ── Titre ── */\n.quittance-title-wrapper {\n    text-align: center;\n    margin-bottom: 16px;\n}\n\n.quittance-title {\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 2px;\n    margin: 0;\n    text-transform: uppercase;\n}\n\n/* ── Blocs sections ── */\n.quittance-block {\n    margin-bottom: 12px;\n}\n\n.quittance-block-title {\n    margin: 0;\n    padding: 5px 10px;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n    color: #fff;\n    background: #1a6b3c;\n    text-transform: uppercase;\n}\n\n/* ── Tableaux - règle unique, pas de surcharge ── */\n.quittance-ref-table,\n.quittance-payment-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n    table-layout: auto;\n}\n\n.quittance-ref-table td {\n    padding: 6px 10px;\n    border: 0.5px solid #a7f3d0;\n    vertical-align: middle;\n    font-size: 13px;\n}\n\n.quittance-ref-label {\n    width: 42%;\n    font-weight: 600;\n    background: #f0fdf4;\n}\n\n.quittance-ref-value {\n    font-weight: 400;\n}\n\n.quittance-payment-table th,\n.quittance-payment-table td {\n    padding: 6px 8px;\n    border: 0.5px solid #a7f3d0;\n    vertical-align: middle;\n    font-size: 12px;\n    text-align: left;\n}\n\n.quittance-payment-table thead tr {\n    background: #f0fdf4;\n}\n\n.quittance-payment-table th {\n    font-weight: 700;\n    font-size: 11px;\n    text-transform: uppercase;\n}\n\n/* ── Préjudices réglés et total, en deux encadrés ──\n   `align-items: start` : les deux encadrés gardent leur hauteur propre. Étirés à\n   la même hauteur, un libellé de préjudice sur deux lignes laissait sous le\n   montant un vide qui se lisait comme une case à remplir. */\n.quittance-totaux {\n    display: flex;\n    gap: 16px;\n    align-items: start;\n}\n\n.quittance-encadre {\n    flex: 1 1 0;\n    min-width: 0;\n    border: 0.5px solid #a7f3d0;\n}\n\n/* Le total est la valeur qu'on vient vérifier : il ne suit pas la largeur du\n   libellé, il occupe une colonne fixe et lisible. */\n.quittance-encadre--total {\n    flex: 0 0 210px;\n}\n\n.quittance-encadre-titre {\n    background: #1a6b3c;\n    color: #fff;\n    font-weight: 700;\n    font-size: 12px;\n    text-transform: uppercase;\n    padding: 7px 10px;\n}\n\n.quittance-encadre-valeur {\n    padding: 7px 10px;\n    font-size: 13px;\n}\n\n.quittance-encadre-montant {\n    text-align: right;\n    font-weight: 700;\n}\n\n/* ── Texte engagement ── */\n.quittance-engagement {\n    margin-top: 16px;\n    font-size: 13px;\n    line-height: 1.9;\n}\n\n.quittance-engagement p {\n    margin: 4px 0;\n    text-align: justify;\n}\n\n/* ── Signatures ── */\n.quittance-signatures {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 32px;\n    gap: 24px;\n}\n\n.quittance-signature-col {\n    flex: 1;\n    text-align: center;\n}\n\n.quittance-signature-label {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n    color: #1a6b3c;\n    border-bottom: 1px solid #1a6b3c;\n    padding-bottom: 4px;\n    display: block;\n}\n\n.quittance-signature-space {\n    height: 45px;\n}\n\n/* ── Pied de page ── */\n.quittance-footer {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n    font-size: 12px;\n    border-top: 0.5px solid #a7f3d0;\n    padding-top: 8px;\n    color: #555;\n}\n\n.quittance-footer-dots {\n    color: #1a6b3c;\n    font-family: monospace;\n}\n\n/* ══ IMPRESSION ══ */\n@media print {\n    @page {\n        size: A4 portrait;\n        margin: 0;\n    }\n\n    .quittance-container {\n        width: 210mm;\n        min-height: 297mm;\n        padding: 12mm 15mm;\n        margin: 0;\n        box-shadow: none;\n        font-size: 13px;\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n}\n\n/* ── En-tete commun aux documents du Bureau ─────────────────────────────────\n   Reproduit l'en-tete de l'offre CIMA (jsPDF) : trois colonnes, embleme au\n   centre, filet vert. Voir EnteteDocumentBncb.js - les deux implementations\n   sont a tenir en accord, elles ne partagent aucun code. */\n.bncb-entete {\n    margin-bottom: 14px;\n}\n\n.bncb-entete-accent {\n    height: 3px;\n    background: #1a6b3c;\n    margin-bottom: 8px;\n}\n\n/* Les colonnes laterales partagent la meme base de largeur : l'embleme tombe\n   ainsi au centre optique de la feuille, et non au milieu de ce qui reste une\n   fois les titres poses. */\n.bncb-entete-grille {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    padding-bottom: 8px;\n    border-bottom: 1.2px solid #1a6b3c;\n}\n\n.bncb-entete-col {\n    flex: 1 1 0;\n    min-width: 0;\n    text-align: center;\n}\n\n.bncb-entete-col--centre {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.bncb-entete-titre {\n    font-size: 10.5px;\n    font-weight: 700;\n    line-height: 1.5;\n    letter-spacing: .2px;\n    color: #000;\n    text-transform: uppercase;\n}\n\n.bncb-entete-logo {\n    width: 62px;\n    height: 62px;\n    object-fit: contain;\n}\n\n.bncb-entete-legende {\n    font-size: 7.5px;\n    color: #8c8c8c;\n    margin-top: 2px;\n}\n\n.bncb-entete-mention {\n    text-align: right;\n    font-size: 11px;\n    color: #333;\n    margin-top: 6px;\n}\n\n/* Les en-tetes de colonnes sont centres : une etiquette courte calee a gauche\n   au-dessus d'une valeur large se lit comme si elle appartenait a la colonne\n   precedente. */\n.quittance-payment-table th {\n    text-align: center;\n}\n\n/* Les prix sont soulignes : sur une decharge, ce sont les valeurs qu'on vient\n   verifier, et le soulignement les designe sans les alourdir. */\n.quittance-montant {\n    text-decoration: underline;\n    text-underline-offset: 2px;\n}\n\n/* De l'air avant les signatures : collees au dernier paragraphe, elles se\n   lisaient comme la suite du texte plutot que comme un bloc a remplir. */\n.quittance-signatures {\n    margin-top: 54px;\n}\n\n/* ── Pied de page commun aux documents du Bureau ────────────────────────────\n   Repris de l'offre CIMA : un filet gris, puis les coordonnees en petit.\n   Voir PiedDocumentBncb.js. */\n.bncb-pied {\n    margin-top: 18px;\n    padding-top: 6px;\n    border-top: 0.6px solid #c8c8c8;\n    text-align: center;\n    font-size: 8px;\n    line-height: 1.5;\n    color: #969696;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
